import MobileHidden from './MobileHidden';

export default MobileHidden;
